<template>
    <div v-if="articles.length" ref="carousel" class="slim-carousel">
        <a
            v-if="showArrow"
            href="#"
            class="slim-carousel__control slim-carousel__control--left js-slime-carousel-left"
            :class="typeNavigation"
            :aria-label="$t('slides.previous')"
        >
            <img :src="`/nuxt-assets/icons/arrow.svg`" alt="arrow" width="11" height="20" data-not-lazy />
        </a>
        <a
            v-if="showArrow"
            href="#"
            class="slim-carousel__control slim-carousel__control--right js-slime-carousel-right"
            :class="typeNavigation"
            :aria-label="$t('slides.next')"
        >
            <img :src="`/nuxt-assets/icons/arrow.svg`" alt="arrow" width="11" height="20" data-not-lazy />
        </a>
        <div class="slim-carousel__container js-slim-carousel-scroll-container elements-carousel-container">
            <div
                v-for="(article, index) in articles"
                :key="index"
                class="slim-carousel__item"
                :class="typeItem"
                data-cy="slim-carousel__item"
            >
                <ArticleCard v-if="mode === 'article'" :article="article" />
                <TopArticleCard v-else :top-article="article" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import SlimCarousel from '~/mixins/SlimCarousel'
import Article from '~/models/StaticContent/Article/Article'
import ArticleCard from '~/components/layout/article/cards/ArticleCard.vue'
import TopArticleCard from '~/components/layout/article/cards/TopArticleCard.vue'

export default {
    components: {
        ArticleCard,
        TopArticleCard,
    },
    props: {
        articles: {
            type: Array as PropType<Article[]>,
            default: () => [],
        },
        typeItem: {
            type: String,
            default: 'slim-carousel__item--top-article',
        },
        typeNavigation: {
            type: String,
            default: null,
        },
        showPreBasket: {
            type: Boolean,
            default: true,
        },
        itemListName: {
            type: String,
            default: '',
        },
        carouselName: {
            type: String,
            default: '',
        },
        mode: {
            type: String,
            required: false,
            default: 'top-article',
        },
    },

    computed: {
        showArrow() {
            return this.articles.length > (this.mode === 'article' ? 4 : 2) || this.$device.isMobile
        },
    },

    updated() {
        if (this.$refs.carousel) {
            if (this.$refs.carousel.getElementsByClassName(this.mode).length) {
                new SlimCarousel({ el: this.$refs.carousel })
            }
        }
    },

    mounted() {
        if (this.$refs.carousel) {
            if (this.$refs.carousel.getElementsByClassName(this.mode).length) {
                new SlimCarousel({ el: this.$refs.carousel })
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.slim-carousel {
    position: relative;
    padding: 0;

    &--fullWidth {
        width: calc(100% + (2 * $padding-container-inside-mobile));
        margin-left: -$padding-container-inside-mobile;

        @media only screen and (min-width: 576px) {
            width: calc(100% + (2 * $padding-container-inside));
            margin-left: -$padding-container-inside;
        }

        @media (min-width: $max-width-container-inside) {
            width: calc(100% + 12px); //margin on .article
            margin-left: -6px;
        }

        &:deep(.slim-carousel__control--left) {
            @media (min-width: 1350px) {
                left: -16px;
            }
        }

        &:deep(.slim-carousel__control--right) {
            @media (min-width: 1350px) {
                right: -16px;
            }
        }
    }
}

.slim-carousel__control {
    display: none;
    padding-left: 3px;

    &:hover {
        @media (min-width: 1024px) {
            background-color: $color-purple-dark;
        }
    }

    @media (min-width: 890px) {
        position: absolute;
        top: calc(50% - 42px);
        width: 33px;
        height: 33px;
        border-radius: 33px;
        transition: all 0.3s;
        z-index: 5;
        background: $color-purple;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &--left {
        @media (min-width: 890px) {
            left: 0;
            transform: rotate(180deg);
        }
    }

    &--right {
        @media (min-width: 890px) {
            right: 0;
        }
    }

    &--outside {
        &.slim-carousel__control--left {
            @media (min-width: 890px) {
                left: -16px;
            }
        }

        &.slim-carousel__control--right {
            @media (min-width: 890px) {
                right: -16px;
            }
        }
    }

    &:deep(svg) {
        margin-left: 4px;
        fill: $color-white;
    }
}

.slim-carousel__container.elements-carousel-container {
    display: flex;
    padding: 5px 0;
    height: auto;
    overflow-x: auto;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    @media (min-width: $max-width-container-inside) {
        padding: 19px 0;
        margin-top: -19px;
    }

    &::-webkit-scrollbar {
        -webkit-appearance: none;
        height: 10px;
    }

    &:hover::-webkit-scrollbar-thumb {
        border: 0;
        background-color: $color-grey-semi-dark;
        border-radius: 10px;
        cursor: pointer;

        @media (min-width: 890px) {
            display: none;
        }
    }
}

.slim-carousel__item {
    &--article {
        display: flex;
        flex: 0 0 calc(100% / 1.2);
        width: calc(100% / 1.2);
        padding-right: calc(var(--bs-gutter-x) * 0.5);
        padding-left: calc(var(--bs-gutter-x) * 0.5);

        @media (min-width: 460px) {
            flex: 0 0 25%;
            width: 25%;
        }

        .article {
            width: 100%;
        }
    }

    &--top-article {
        display: flex;
        flex: 0 0 calc(100% / 1.2);
        width: calc(100% / 1.2);

        @media (min-width: 460px) {
            flex: 0 0 calc(100% / 2.5);
            width: calc(100% / 2.5);
        }
    }
}
</style>
